<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'setting-point'"
    @hidden="$emit('onCloseModal')"
  >
    <template #modal-header>
      <div class="d-flex justify-content-between font-medium-4">
        <div class="d-flex align-item-center w-100">
          <icon-star class="mr-2" />
          {{
            modalData.rewardType == TYPE.REWARDTYPE.POINT
              ? "กำหนดแต้ม"
              : "Set Reward"
          }}
        </div>
        <div class="d-flex">
          <div class="mr-2 reward-equal-wrp">
            <div>สมาชิก</div>
            <div>
              {{
                modalData.rewardType == TYPE.REWARDTYPE.POINT
                  ? "ได้แต้มไม่เท่ากัน"
                  : "ได้ของรางวัลไม่เหมือนกัน"
              }}
            </div>
          </div>
          <div class="reward-wrp">
            <div>ตอบครบทุกข้อ</div>
            <div>
              {{
                modalData.rewardType == TYPE.REWARDTYPE.POINT
                  ? "เพื่อรับแต้ม"
                  : "เพื่อรับของรางวัล"
              }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <b-row v-if="modalData.rewardType == TYPE.REWARDTYPE.POINT">
      <b-col>
        <div
          v-for="(item, index) in modalData.permissionListSetting"
          :key="index"
          class="d-flex align-item-center justify-content-between mb-1 mt-2"
        >
          <div class="d-flex align-item-center w-100">
            <div class="mr-4">{{ index + 1 }}</div>
            <div class="tag-name-wrp">{{ item.tagName }}</div>
          </div>
          <div>
            <input-spin-quiz
              :numValue="item.point || 0"
              :isInputDisabled="false"
              @update-number="onUpdatePoint($event, index)"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <div class="mt-2 pl-2">
          <label for="select-inventory" class="font-medium-4 text-black">
            <span> Choose Inventory </span>
          </label>
          <v-select
            v-model="modalData.selectInventory"
            class="select-format-container font-medium-5 bg-dropdown"
            placeholder="Master Inventory"
            :clearable="false"
            :options="optionData.inventoryList"
            :reduce="(option) => option.value"
            @input="fetchPrivilegeList(modalData.selectInventory, true)"
            @option:selected="onChangeInventory()"
          />
        </div>
        <div
          v-for="(item, index) in modalData.permissionListSetting"
          :key="index"
          class="d-flex align-item-center justify-content-between mb-1 mt-2"
        >
          <div class="d-flex align-item-center w-100">
            <div class="mr-4">{{ index + 1 }}</div>
            <div class="tag-name-wrp">{{ item.tagName }}</div>
          </div>
          <div class="w-60">
            <v-select
              v-model="item.selectPrivilege"
              class="select-format-container font-medium-5 bg-dropdown"
              placeholder="Select Privilege"
              :clearable="false"
              :searchable="true"
              :options="optionData.privilegeList"
              :reduce="(option) => option.value"
              @option:selected="onChangePrivilege(item.selectPrivilege, index)"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="modal-btn-wrp btn-wrp mt-2 mb-2">
          <div class="d-flex justify-content-center mt-2">
            <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
            <save-button
              :btnLabel="'Apply'"
              type="submit"
              class="ml-1 btn-save"
              @click.native="
                $emit(
                  'onSubmitSettingPoint',
                  modalData,
                  optionData.privilegeList
                )
              "
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  getCurrentInstance,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import IconStar from "@/@core/components/svg/common/IconStar.vue";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";

export default {
  components: { IconStar, InputSpinQuiz },
  props: {
    modalData: { type: Object, default: {} },
    optionData: { type: Object, default: {} },
    TYPE: { type: Object, default: {} },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onUpdatePoint = (point, index) => {
      vm.$emit("onUpdatePoint", point, index);
    };

    const fetchPrivilegeList = (inventoryId, isChageInventory) => {
      vm.$emit("fetchPrivilegeList", inventoryId, isChageInventory);
    };

    const onChangePrivilege = (selectPrivilege, index) => {
      vm.$emit("onChangePrivilege", selectPrivilege, index);
    };

    const onChangeInventory = () => {
      vm.$emit("onChangeInventory");
    };
    return {
      onUpdatePoint,
      fetchPrivilegeList,
      onChangePrivilege,
      onChangeInventory,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/survey/privilege.css";
</style>